import { UseQueryResult, useQuery } from 'react-query'

import { Product } from 'components/product-card'

import httpClient from 'services/http-client'

export const GET_ALL_FAVOURITE_PRODUCTS = '/retailers/favourites/products/?lang='

export const useGetFavouriteProducts = (lang: string, enabled = true): UseQueryResult<Product[]> =>
  useQuery({
    enabled: enabled,
    queryKey: [GET_ALL_FAVOURITE_PRODUCTS, lang],
    queryFn: async () => {
      const { data: products } = await httpClient.get<Product[]>(GET_ALL_FAVOURITE_PRODUCTS + lang)
      return products
    },
  })
